// import Vue from 'vue'
// import VueRouter from 'vue-router'
import { updateSeoMeta } from '@/utils/seo'

Vue.use(VueRouter)

const routes = [
    {
        path:'/',
        redirect:'/index'
    },
    {
        path: '/index',
        name: 'index',
        component: () => import('../views/IndexView.vue')
    },
    {
        path: '/product',
        name: 'product',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/features',
        name: 'features',
        component: () => import('../views/ProductView.vue'),
    },
    {
        path: '/compare',
        name: 'compare',
        component: () => import('../views/CompareView.vue'),
    },
    {
        path: '/cases',
        name: 'cases',
        component: () => import('../views/ExampleView.vue'),
    },
    {
        path: '/packages',
        name: 'packages',
        component: () => import('../views/PackageView.vue'),
    },
    {
        path: '/partners',
        name: 'partners',
        component: () => import('../views/PartnerView.vue'),
    },
    {
        path: '/help',
        name: 'help',
        component: () => import('../views/HelpView.vue'),
    },
    {
        path: '/calculator',
        name: 'calculator',
        component: () => import('../views/QuoteView.vue'),
    },
    {
        path: '/contract-sign',
        name: 'contractSign',
        component: () => import('../views/ContractSignView.vue'),
    },
    {
        path: '/contact',
        name: 'contact',
        component: () => import('../views/ContactView.vue'),
    },
    {
        path: '/login',
        name: 'login',
        component: () => import('../views/LoginView.vue'),
    },
    {
        path: '/product/productId/:productId',
        name: 'productDetails',
        component: () => import("../views/ProductDetailsView.vue")
    },
    {
        path: '/example',
        name: 'example',
        component: () => import('../views/ExampleView.vue')
    },
    {
        path: '/news',
        name: 'news',
        component: () => import('../views/NewsView.vue')
    },
    {
        path: '/news/newsId/:newsId',
        name: 'newsDetails',
        component: () => import('../views/NewsDetailsView.vue')
    },
    {
        path: '/about',
        name: 'about',
        component: () => import('../views/AboutView.vue')
    },
    {
        path: '/try',
        redirect: '/contact'
    },
    {
        path: '/app-download',
        name: 'appDownload',
        component: () => import('../views/AppDownloadView.vue')
    },
]

const router = new VueRouter({
    routes,
    scrollBehavior() {
        return { x: 0, y: 0 }
    }
})

// 全局路由后置钩子：每次页面切换自动更新 SEO meta 信息
router.afterEach((to) => {
    updateSeoMeta(to.name, to.path)
})

export default router
